import { AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import { ORGANIZATIONS_URL } from "@/api/URL-constants";

import { OrganizationResponse } from "@/models/api/organization.model";

const get = (): Promise<AxiosResponse<OrganizationResponse>> => {
  return DAO_SESHAT().get(ORGANIZATIONS_URL);
};

export { get };
